import { MatTableDataSource } from '@angular/material/table';
import { ExportProfileDto } from 'src/app/data-transfer/entities/export-profile-dto';

export class ExportProfilesDataSource extends MatTableDataSource<ExportProfileDto>
{
}
